import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'sume-checkbox',
    templateUrl: './checkbox.component.html',
})
export class CheckboxComponent implements OnInit {
    @Input() value: boolean;
    @Input() id: string;
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() labelOnTop = true; // label em cima ou do lado
    @Input() toggleSwitch = false;

    @Output() valueChange = new EventEmitter<boolean>();

    constructor() {}

    ngOnInit(): void {}

    onNewValue(value: boolean) {
        this.valueChange.emit(value);
    }
}
